export default __webpack_public_path__ + "static/home-care-science-29dd20984ef9376f79e56fd43dcdcf78.mp4";